import CreateGfpItems from '../../model/gfp/CreateGfpItems';
import Order from '../../model/order/Order';

export class MapOrderSelectedToGfpItems {
  static toGfpItems(orderSelected: Order[], campaignId?: number): CreateGfpItems[] {
    const items: CreateGfpItems[] = [];

    for (let i = 0; i < orderSelected.length; i++) {
      const order = orderSelected[i];
      items.push({
        saleTransactionId: order.orderId,
        packingId: order.packingId as number,
        quantityPacking: order.quantityPacking,
        unitQuantity: order.quantityPerPacking,
        obs1: order.observationId1 || undefined,
        obs2: order.observationId2 || undefined,
        observation: order.observation,
        gfpObservation: order.gfpObservation || '',
        campaignId,
      });
    }
    return items;
  }
}
